__turbopack_context__.v({
  "calloutSection": "v6gpqa_calloutSection",
  "calloutSectionTextColumn__kgZpF": "v6gpqa_calloutSectionTextColumn__kgZpF",
  "calloutSectionTextColumn__mGMnL": "v6gpqa_calloutSectionTextColumn__mGMnL",
  "calloutSectionTextColumn__wxx4L": "v6gpqa_calloutSectionTextColumn__wxx4L",
  "desktop": "v6gpqa_desktop",
  "mobile": "v6gpqa_mobile",
  "tablet": "v6gpqa_tablet",
  "wrapper": "v6gpqa_wrapper",
  "wrapper3": "v6gpqa_wrapper3",
  "wrapper4": "v6gpqa_wrapper4",
});
